import ApiService from "../api.service";
import appConfig from "../../../app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const GoodsReturnService = {
  async getGoodsInByCode(code) {
    const requestScreenData = {
      url: "api/GoodsIn",
      top: "1",
      expand: "Supplier($select=Name,CurrencyCode)",
      filter: `Code eq ${code}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getGoodsInDetailByCode(code) {
    const requestScreenData = {
      url: "api/GoodsInDetail",
      top: "1",
      filter: `GoodsInCode eq ${code}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  dataSourceConfig(params) {
    var url = "api/GoodsInDetail";
    return ApiService.createDataSource(url, params);
  },

  async getGoodsInBatches(code, lineNo) {
    const requestScreenData = {
      url: "api/GoodsInProductBatch",
      // top: "1",
      filter: `GoodsInCode eq ${code} and GoodsInLineNo eq ${lineNo}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async saveGoodsInReturnOrder(payload) {
    var url = `api/Save_GoodsReturn`;
    // var url = `api/Save_PickingSlip`;
    return await ApiService.post(url, payload);
  },
  async getActiveAccountingPeriodStartDate() {
    const requestScreenData = {
      url: "api/ActiveAccountingPeriod",
      top: "1",
      filter: `PeriodType eq 'STK'`,
      orderby: "StartDate",
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  async getActiveAccountingPeriodEndDate() {
    const requestScreenData = {
      url: "api/ActiveAccountingPeriod",
      top: "1",
      filter: `PeriodType eq 'STK'`,
      orderby: "EndDate desc",
    };

    return await ApiService.oDataGet(requestScreenData);
  },
};

export { GoodsReturnService };
